import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { forkJoin, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

import { ApiConfiguration, apiParentStudentsMineGet$Json } from 'amoxcalli-identity-api';
import { apiStudentsIdForParentGet$Json, AmoxcalliStudentForParentDto } from 'amoxcalli-academic-api';

import { environment } from '../../../../environments/environment';
import { HijosActions } from './hijos.actions';
import { HijoResumen } from './hijos.state';

function fullName(dto: AmoxcalliStudentForParentDto): string {
  return [dto.name, dto.lastName, dto.motherLastName].filter(Boolean).join(' ');
}

@Injectable()
export class HijosEffects {
  private readonly actions$ = inject(Actions);
  private readonly http     = inject(HttpClient);
  private readonly config   = inject(ApiConfiguration);

  loadHijos$ = createEffect(() =>
    this.actions$.pipe(
      ofType(HijosActions.loadHijos),
      switchMap(() =>
        apiParentStudentsMineGet$Json(this.http, this.config.rootUrl).pipe(
          switchMap((response) => {
            const links = response.body ?? [];
            if (links.length === 0) {
              return of(HijosActions.loadHijosSuccess({ hijos: [] }));
            }

            const requests = links.map((link) =>
              apiStudentsIdForParentGet$Json(this.http, environment.serverUrl.academic, {
                id: link.studentId!,
              }).pipe(
                map((res): HijoResumen => {
                  const dto = res.body as AmoxcalliStudentForParentDto;
                  return {
                    studentId: link.studentId!,
                    relacion:  link.relacion ?? null,
                    matricula: dto.matricula ?? '',
                    nombre:    fullName(dto),
                    gradoName: dto.gradeName ?? '',
                    groupName: dto.groupName ?? '',
                    institutionName: dto.institutionName ?? '',
                    teacherName:     dto.teacherName ?? '',
                  };
                })
              )
            );

            return forkJoin(requests).pipe(
              map((hijos) => HijosActions.loadHijosSuccess({ hijos }))
            );
          }),
          catchError(() =>
            of(HijosActions.loadHijosFailure({ error: 'No se pudieron cargar tus hijos.' }))
          )
        )
      )
    )
  );
}
